import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { setProfileIdentity } from '@/auth/session';

export const TokenSync: React.FC = () => {
  const { events } = useAuth();

  useEffect(() => {
    const handleUnload = () => setProfileIdentity(undefined);

    events.addUserUnloaded(handleUnload);

    return () => events.removeUserUnloaded(handleUnload);
  }, [events]);

  return null;
};
